<template>
  <div v-if="data">
    <div class="container container-fluid">
      <div class="jumbotron" v-show="!closeJumbotron">
        <span class="top-right" @click="closeJumbo()">&times;</span>
        <p class="lead">Välkommen till <strong>FH</strong>abians kliniska gränssnitt.</p>
        <p>
          Du navigerar dig vidare genom att använda någon av knapparna nedan.
        </p>
      </div>
      <div class="jumbotron jumbotron--bg">
        <h4 class="text-muted pull-center">Välj antingen kaskadscreening eller prescreening</h4>
        <div class="clearfix"></div>
        <button class="btn btn-lg btn-lpage bg--gen-positive border" type="button" @click="goToModule('gen_positive')">
          Kaskadscreening av gen positiv FH
        </button>
        <div class="clearfix"></div>
        <button class="btn btn-lg btn-lpage bg--gen-negative border" type="button" @click="goToModule('gen_negative')">
          Kaskadscreening av gen negativ FH
        </button>
        <div class="clearfix"></div>
        <button class="btn btn-lg btn-lpage bg--cardio border" type="button" @click="goToModule('cardio')">
          Prescreening av kardiologpatienter
        </button>
        <div class="clearfix d-block d-sm-none"></div>
      </div>
    </div>
    <vue-cookie-accept-decline
    :ref="'cookies'"
    :elementId="'cookies'"
    :debug="false"
    :position="'bottom-left'"
    :type="'floating'"
    :disableDecline="true"
    :transitionName="'slideFromBottom'"
    :showPostponeButton="false">
      <div slot="message">
        Denna sida använder cookies. <br />
        Läs mer <a href="https://www.pts.se/cookies" target="_blank">här</a>.
      </div>
      <div slot="acceptContent">Jag förstår</div>
    </vue-cookie-accept-decline>
  </div>
</template>

<script>
import $ from 'jquery'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { parseJwt } from '../plugins/jwtparser'
import { request } from '../plugins/datocms'

export default {
  name: 'landingpage',
  components: {
  },
  data () {
    return {
      data: null,
      closeJumbotron: (localStorage.getItem('jumbotron-closed-todo') === 'true') || false,
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa'
    }
  },
  methods: {
    // Not in use
    highlightMenu () {
      var $nav = $('#left-nav')
      var duration = 2000
      var originalColor = $nav.css('background')
      $nav.css('background', '#6D6F74')
      setTimeout(function () {
        $nav.css('background', originalColor)
      }, duration)
    },
    closeJumbo () {
      localStorage.setItem('jumbotron-closed-todo', true)
      this.closeJumbotron = true
    },
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    goToModule (module) {
      switch (module) {
        case 'gen_positive':
          this.$root.$emit('patientType', 2)
          this.$router.push('todo')
          break
        case 'gen_negative':
          this.$root.$emit('patientType', 1)
          this.$router.push('todo_gen_negative')
          break
        case 'cardio':
          this.$root.$emit('patientType', 3)
          this.$router.push('todocardio')
          break
        default:
          break
      }
    },
    async getTokenWithMetaInfo () {
      const sessionId = localStorage.getItem('sessionId')
      axios.postToken(config.tokenUri, String(sessionId)).then((response) => {
        if (response) {
          localStorage.setItem('jwt', response.data.token)
          const decodedJwt = parseJwt(response.data.token)
          if (decodedJwt) {
            this.$root.$emit('setName', decodedJwt.givenName + ' ' + decodedJwt.surName)
            this.$root.$emit('setClinic', decodedJwt.clinicName)
            localStorage.setItem('fullname', decodedJwt.givenName + ' ' + decodedJwt.surName)
            localStorage.setItem('clinicName', decodedJwt.clinicName)
            localStorage.setItem('clinicianId', decodedJwt.clinicianId)
            localStorage.setItem('hsaId', decodedJwt.hsaId)
            this.setRegionCodeFromHsaId(decodedJwt.hsaId)
          }
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log(error)
        }
      })
    },
    setRegionCodeFromHsaId (hsaId) {
      if (hsaId && hsaId.includes('-')) {
        hsaId = hsaId.substr(0, hsaId.indexOf('-')).toLowerCase()
        hsaId = hsaId.charAt(0).toUpperCase() + hsaId.slice(1)
        localStorage.setItem('regioncode', hsaId)
      }
    }
  },
  async beforeMount () {
    const sithsDev = localStorage.getItem('sithsDev') === 'true'
    if ((!this.isDev && !this.isQa) || sithsDev) {
      await this.getTokenWithMetaInfo()
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          faq {
            faqClinicText
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.pull-left {
  text-align: left;
}
.pointer {
  cursor: pointer;
}
.top-right {
  position: absolute;
  top: 0;
  right: 0;
  margin: 5px 15px 0px 0px;
  cursor: pointer;
  transform: scale(1.5);
}
.btn-lpage {
  width: 35vw;
}
.lh-1 {
  line-height: 1;
}
.container {
  margin-left: 1vw;
  min-width: 90vw;
}
.jumbotron--bg {
  background: rgb(57, 155, 200, 0.2);
}
.jumbotron--bg > button {
  z-index: 999;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/LandingPage.vue